module.exports = __webpack_public_path__ + "static/media/nyan-cat.ed012259.gif";